module.exports = __webpack_public_path__ + "img/service-bottom2.b0c9033d.png";